import React, { useState, useRef, useEffect } from 'react'
import Layout from "../../../NewComponent/Layout/Layout";
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
 import {Actions} from '../../../Action/index';
import NewSearchBar from './NewSearchBar';
import Container from './Container';
import LayoutExpert from "../../../NewComponent/LayoutExpert/Layout";
import { CURRENT_ROLE } from '../../../API/url';


export default function Briefing() {
    const dispatch = useDispatch();
    const {briefAgenticIsIframe} = bindActionCreators(Actions, dispatch);
    const [accessToken, setValue] = useState(localStorage.getItem('accessToken'));
  const briefState = useSelector((state) => state.brief);
  const userState = useSelector((state) => state.user);
    const containerStyles = {
        width: "70%",
        margin: "auto",
        // marginTop: "1%",
        marginBottom: "7%",
        // border: '1px solid #EAECF0',
        // boxShadow: '0px 4px 16px 0px #1018280F',
        borderRadius:'12px',
        // background:'#ffffff',
        // padding:'24px',
        // display:'flex',
        // justifyContent:'space-between'
      };
      const container1Styles = {
        width:'100%',
    };
    const container2Styles = {
        width:`${briefState.isOpen?'7%':'20%'}`,
        border: '1px solid #EAECF0',
        // boxShadow: '0px 4px 16px 0px #1018280F',
        borderRadius:'12px',
        // minHeight:'450px',
        padding:'24px',
        // display:`${isShow?'none':''}`
    
      };
      const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    display:'none'
  },
  modal: {
    position: 'relative',
    width: '80px',
    height: '80px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 0 20px rgba(0,0,0,0.3)',
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 15,
    fontSize: 18,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    zIndex: 10000,
  },
};
useEffect(() => {
    const interval = setInterval(() => {
      const newValue = localStorage.getItem('accessToken');
      if (newValue !== accessToken) {
        setValue(newValue); // update state if localStorage value changed
      }
    }, 1000); // check every 1 second (or use a shorter delay if needed)

    return () => clearInterval(interval);
  }, [accessToken]);
  return (
    <>
    {CURRENT_ROLE==='Seeker'&&<Layout>
        <div style={containerStyles}>
           {/* <Main/> */}
           <Container/>
           <NewSearchBar/>
        </div>
    </Layout>}
    {CURRENT_ROLE==='Expert'&&<LayoutExpert>
        <div style={containerStyles}>
           {/* <Main/> */}
           <Container/>
           <NewSearchBar/>
        </div>
    </LayoutExpert>}
    </>
  )
}
